import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as authActions from '../../actions/authAction';
import toastr from 'toastr';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import {Card, CardText} from 'material-ui/Card';
import AuthApi from '../../api/authApi';

class LoginPage extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            credentials: {
                email: '',
                password: ''
            }
        };

        this.onChange = this.onChange.bind(this);
        this.onLogin = this.onLogin.bind(this);
    }

    componentWillMount() {
        const redirect = this.getRedirectURL();
        if (AuthApi.isLoggedIn()) {
            this.context.router.push(redirect);
        }
    }

    componentWillReceiveProps(nextProps) {
        const redirect = this.getRedirectURL();
        if (AuthApi.isLoggedIn()) {
            this.context.router.push(redirect);
        } else if (nextProps.user && nextProps.user.error) {
            toastr.error(nextProps.user.error);
        }
    }

    getRedirectURL() {
        let search = location.search.substring(1);
        if (search.length > 0) {
            search = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
            if (search.redirect) return decodeURIComponent(search.redirect);
        }
        return '/';
    }

    onChange(event) {
        const field = event.target.name;
        let credentials = this.state.credentials;
        credentials[field] = event.target.value;
        this.setState({credentials: credentials});
    }

    onLogin(event) {
        this.props.actions.login(this.state.credentials).then((response)=>{

        },(errorMessage)=>{
            toastr.error(errorMessage);
        });
    }


    render() {
        return (
            <Card style={{width: 400, margin: '0 auto'}}>
                <CardText>
                    <div>
                        <TextField
                            fullWidth
                            hintText="Email"
                            floatingLabelFixed
                            floatingLabelText="Email"
                            name="email"
                            type="email"
                            autocomplete="off"
                            onChange={this.onChange}
                        />
                    </div>
                    <div>
                        <TextField
                            fullWidth
                            hintText="Mot de passe"
                            floatingLabelFixed
                            floatingLabelText="Mot de passe"
                            name="password"
                            type="password"
                            autocomplete="off"
                            onChange={this.onChange}
                        />
                    </div>
                    <div>
                        <RaisedButton fullWidth label="Se connecter" primary onClick={this.onLogin}/>
                    </div>
                </CardText>
            </Card>
        );
    }
}

LoginPage.contextTypes = {
    router: PropTypes.object
};

LoginPage.propTypes = {
    actions: PropTypes.object.isRequired,
    user: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {
        user: state.me
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(authActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);


/** WEBPACK FOOTER **
 ** ./src/components/auth/LoginPage.js
 **/